// The renderer is written with React.createElement (`h`), not JSX, so its fields can be rendered and tested with
// `node --test` and react-dom/server without a build step. Consumers' bundlers treat it like any other module.
import { createElement } from "react";

export const h = createElement;
